// extracted by mini-css-extract-plugin
export var circle = "_gp-1";
export var exitConfirmationModal = "_gp-5";
export var iframe = "_gp-0";
export var offline = "_gp-3";
export var online = "_gp-2";
export var workstationSelectError = "_gp-4";